import { REPORTS_DEFAULT_FILTERS } from '@constants/Reports/reportsDefaultToolbar.constants'

export const TREATMENT_CONVERSION_FUNNEL_FILTERS = REPORTS_DEFAULT_FILTERS

export const TREATMENT_CONVERSION_FUNNEL_KPI_DEFINITIONS: Array<{
  id: string
  title: string
  footer: string
  format: 'percent' | 'currency' | 'count'
}> = [
  {
    id: 'treatment-acceptance-rate',
    title: 'Treatment Acceptance Rate',
    footer: 'Accepted plans / diagnosed plans',
    format: 'percent',
  },
  {
    id: 'unscheduled-treatment-value',
    title: 'Unscheduled Treatment Value',
    footer: 'Accepted unscheduled treatment',
    format: 'currency',
  },
  {
    id: 'exam-unscheduled-cases',
    title: 'Exam-based Unscheduled Cases',
    footer: 'Cases',
    format: 'count',
  },
  {
    id: 'completed-vs-diagnosed',
    title: 'Completed vs Diagnosed Ratio',
    footer: 'Completed plans / diagnosed plans',
    format: 'percent',
  },
]

export type ExamUnscheduledProviderRow = {
  id: string
  provider: string
  examDiagnoses: number
  unscheduledCount: number
  unscheduledPct: number
}

/** PDF preview provider table body (still mock until preview API exists). */
export const EXAM_UNSCHEDULED_PROVIDER_ROWS: ExamUnscheduledProviderRow[] = [
  {
    id: 'smith',
    provider: 'Dr. Smith',
    examDiagnoses: 52,
    unscheduledCount: 18,
    unscheduledPct: 35,
  },
  {
    id: 'patel',
    provider: 'Dr. Patel',
    examDiagnoses: 47,
    unscheduledCount: 16,
    unscheduledPct: 34,
  },
  {
    id: 'snow',
    provider: 'Dr. Snow',
    examDiagnoses: 41,
    unscheduledCount: 12,
    unscheduledPct: 29,
  },
  {
    id: 'emerson',
    provider: 'Dr. Emerson',
    examDiagnoses: 39,
    unscheduledCount: 9,
    unscheduledPct: 23,
  },
  {
    id: 'garcia',
    provider: 'Dr. Garcia',
    examDiagnoses: 35,
    unscheduledCount: 6,
    unscheduledPct: 17,
  },
]

/** PDF / Report Preview mock tables (Treatment Conversion Funnel). */
export const PREVIEW_TCF_SUMMARY_KPI_ROWS: { metric: string; value: string }[] =
  [
    { metric: 'Treatment Acceptance Rate', value: '59%' },
    { metric: 'Unscheduled Treatment Value', value: '$172,000.00' },
    { metric: 'Exam-based Unscheduled Cases', value: '61' },
    { metric: 'Completed vs Diagnosed Ratio', value: '47%' },
  ]

export const PREVIEW_TCF_FUNNEL_STAGE_PREVIEW_ROWS: {
  stage: string
  treatmentValue: string
  patients: string
}[] = [
  { stage: 'Diagnosed', treatmentValue: '$420,000.00', patients: '380' },
  { stage: 'Scheduled', treatmentValue: '$248,000.00', patients: '224' },
  { stage: 'Completed', treatmentValue: '$196,000.00', patients: '178' },
]

export const PREVIEW_TCF_VALUE_BUCKET_PREVIEW_ROWS: {
  bucket: string
  patients: number
  totalValue: string
}[] = [
  { bucket: '$0–$500', patients: 48, totalValue: '$14,400.00' },
  { bucket: '$500–$1,500', patients: 56, totalValue: '$56,000.00' },
  { bucket: '$1,500–$3,000', patients: 27, totalValue: '$54,000.00' },
  { bucket: '$3,000+', patients: 12, totalValue: '$47,600.00' },
]

export const PREVIEW_TCF_VALUE_BUCKET_TOTAL = {
  label: 'Total',
  patients: 143,
  totalValue: '$172,000.00',
}

export const PREVIEW_TCF_PROVIDER_TOTAL_ROW = {
  label: 'Total',
  examDiagnoses: 214,
  unscheduled: 61,
  unscheduledPct: 29,
}

export const PREVIEW_TCF_COMPLETED_VS_DIAGNOSED_MONTHLY: {
  month: string
  diagnosedValue: string
  completedValue: string
  completedRatio: string
}[] = [
  {
    month: 'Jul',
    diagnosedValue: '$66,000.00',
    completedValue: '$30,000.00',
    completedRatio: '45%',
  },
  {
    month: 'Aug',
    diagnosedValue: '$68,000.00',
    completedValue: '$31,000.00',
    completedRatio: '46%',
  },
  {
    month: 'Sep',
    diagnosedValue: '$69,000.00',
    completedValue: '$33,000.00',
    completedRatio: '48%',
  },
  {
    month: 'Oct',
    diagnosedValue: '$71,000.00',
    completedValue: '$34,000.00',
    completedRatio: '48%',
  },
  {
    month: 'Nov',
    diagnosedValue: '$73,000.00',
    completedValue: '$35,000.00',
    completedRatio: '48%',
  },
  {
    month: 'Dec',
    diagnosedValue: '$73,000.00',
    completedValue: '$33,000.00',
    completedRatio: '45%',
  },
]
